import { render, staticRenderFns } from "./DeviceMonthInfo.vue?vue&type=template&id=f85d0c20&scoped=true"
import script from "./DeviceMonthInfo.vue?vue&type=script&lang=js"
export * from "./DeviceMonthInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d0c20",
  null
  
)

export default component.exports